<template>
    <div class="layout-container">
        <slot></slot>
    </div>
</template>

<style>
.layout-container {
    @apply container mx-auto px-6;
}
</style>
